module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/221.d19ea661.png";